import InvestRatingTable from './InvestRatingTable';

export default InvestRatingTable;
